export const habaCatalogForm = {
  habaCatalogForm: {
    heading: 'Demander gratuitement',
    personalData: 'Quelles sont tes données personnelles ?',
    form: {
      title: {
        label: 'Titre de civilité*',
        error: 'Veuillez choisir un titre',
      },
      firstName: {
        label: 'Prénom*',
        error: 'Veuillez saisir votre prénom',
      },
      lastName: {
        label: 'Nom de famille*',
        error: 'Veuillez saisir votre nom de famille',
      },
      address1: {
        label: 'Rue*',
        error: 'Veuillez saisir la rue',
      },
      nr: {
        label: 'Numéro de rue*',
        error: 'Veuillez saisir le numéro',
      },
      birthdate: {
        label: "Date d'anniversaire*",
        error: 'Veuillez saisir votre date de naissance',
      },
      country: {
        label: 'Pays*',
        error: 'Veuillez sélectionner un pays',
      },
      city: {
        label: 'Ville*',
        error: 'Veuillez saisir la ville',
      },
      zipCode: {
        label: 'Code postal*',
        error: 'Veuillez saisir la code postal',
      },
      email: {
        label: 'Adresse e-mail*',
        error: 'Veuillez saisir votre adresse e-mail',
      },
      submit: 'Demander',
    },
  },
};
